import * as React from 'react';
import Input from 'material-ui/Input';
import { Tool } from './tool';
import Button from 'material-ui/Button';
import Tooltip from 'material-ui/Tooltip';
import ExpansionPanel, {
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from 'material-ui/ExpansionPanel';
import Typography from 'material-ui/Typography';
import Icon from 'material-ui/Icon';
import styled from 'styled-components';
/* import ExpandMoreIcon from 'material-ui-icons/ExpandMore';*/
import { Classification,  } from './classification';
import { ClassificationField, ToolType } from '../customization';

const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 15px;
  min-height: 36px;
`;

const ToolbarContainer = styled.div`
  box-shadow: 2px 0px 13px #bfbfbf;
  background-color: white;
  display: flex;
  width: 250px;
  flex-grow: 1;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;

function NestedHeader({title, onClose}: {title: string, onClose: () => void}){
  return (
    <Tooltip title="or press escape" placement="top">
      <div
        style={{padding: '15px 10px 5px 10px', display: 'flex', alignItems: 'center', cursor: 'pointer'}}
        onClick={() => onClose()}
      >
        <Icon style={{color: '#c1c1c1'}} >keyboard_arrow_left</Icon>
        <div>{title}</div>
      </div>
    </Tooltip>
  )
}

function KeyboardShortcutLabel({name, keybinding}:{name: string, keybinding: string}){
  return (
    <div style={{display: 'flex', flexGrow: 1, borderBottom: '1px solid #c1c1c1', fontSize: '12px', padding: '10px 15px', color: 'grey', minHeight: '10px'}}>
      <div style={{display: 'flex', flexGrow: 1}}>
        <div style={{flex: '60'}}>{name}</div>
        <div style={{flex: '40'}}>{keybinding}</div>
      </div>
    </div>
  );
}

class Search extends React.Component {
  private input: any;
  public props: {
    focused: boolean,
    value: string,
    onChange: (value: string) => void
    onFocus: () => void
    onBlur: () => void
  }

  componentDidUpdate(){
    this.input.value = this.props.value;
    if (this.props.focused){
      this.input.focus();
    } else {
      this.input.blur();
    }
  }

  render(){
    return (
      <Tooltip title="or press /" placement="right">
        <Input
          style={{margin: '10px', fontWeight: 500, color: '#5b5b5b', width: '150px', height: '30px'}}
          placeholder="Search class"
          inputRef={(ref) => this.input = ref}
          onFocus={() => this.props.onFocus()}
          onBlur={() => this.props.onBlur()}
          onKeyUp={(e: any) => this.props.onChange(e.target.value)}
        />
      </Tooltip>
    );
  }
}

export function ToolMenu(
  {
    tools,
    classificationFields,
    nestedHeaderTitle,
    toolChange,
    currentTool,
    visibilityToggle,
    disableSubmit,
    onSubmit,
    onSkip,
    onClassificationAnswer,
    editing,
    onReset,
    searchFocused,
    searchValue,
    onSearchChange,
    onSearchFocus,
    onSearchBlur,
    onCloseNestedSection,
  }: {
    tools: {id: string, name: string, color: string, count: number, visible: boolean, tool: ToolType}[];
    classificationFields: ClassificationField[],
    toolChange: (id: string | undefined) => void;
    currentTool: string | undefined;
    visibilityToggle: (toolIndex: string) => void;
    disableSubmit: boolean;
    nestedHeaderTitle: string | undefined;
    onSubmit: () => void;
    onClassificationAnswer: (fieldId: string, answer: string | string[]) => void;
    onSkip: () => void;
    onReset: () => void;
    editing: boolean;
    searchFocused: boolean;
    searchValue: string;
    onSearchChange: (searchValue: string) => void;
    onSearchFocus: () => void;
    onSearchBlur: () => void;
    onCloseNestedSection: () => void;
  }) {
  return (
    <ToolbarContainer>
      <div style={{display: 'flex', flexGrow: '1', flexDirection: 'column', width: '100%'} as any}>
        <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
          <div>
            {
              nestedHeaderTitle ?
                (<NestedHeader title={nestedHeaderTitle} onClose={onCloseNestedSection} />) :
                (
                  <Search
                    focused={searchFocused}
                    value={searchValue}
                    onFocus={onSearchFocus}
                    onBlur={onSearchBlur}
                    onChange={onSearchChange}
                  />
                )
            }
          </div>


          <div style={{overflowY: 'auto', overflowX: 'hidden'}}>
            {tools.map(({id, name, color, count, visible, tool}, index) => (
              <Tool
                name={name}
                key={index}
                tooltip={index < 9 ? ('or press ' + (index + 1)).toString() : undefined}
                toolName={tool}
                color={color}
                count={count}
                visible={visible}
                visibilityToggle={() => visibilityToggle(id)}
                onClick={() => toolChange(id !== currentTool ? id : undefined)}
                selected={id === currentTool}
              />
            ))}
            {classificationFields.map((field) => (
              <Classification
                key={field.id}
                field={field}
                answer={field.userAnswer}
                onAnswer={(answer: string | string[]) => onClassificationAnswer(field.id, answer)}
              />))}
          </div>
        </div>
        <div style={{display: 'flex', flexGrow: '1'} as any}></div>

        <ExpansionPanel style={{boxShadow: 'none', borderBottom: '1px solid #e0e0e0'}}>
          <ExpansionPanelSummary expandIcon={<Icon>keyboard_arrow_up</Icon>}>
            <Typography>Keyboard Shortcuts</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{display: 'flex', flexDirection: 'column', padding: '0px', overflowY: 'auto', maxHeight: '60vh'}}>
            {
              tools.slice(0, 9).map(({name}, index) => (
                <KeyboardShortcutLabel key={index} name={name} keybinding={(index+1).toString()} />
              ))
            }
            <KeyboardShortcutLabel name="Complete shape" keybinding="f"/>
            <KeyboardShortcutLabel name="Undo" keybinding="cmd/ctrl z"/>
            <KeyboardShortcutLabel name="Delete" keybinding="backspace"/>
            <KeyboardShortcutLabel name="Deselect" keybinding="escape"/>
            <KeyboardShortcutLabel name="Submit" keybinding="e"/>
            <KeyboardShortcutLabel name="Skip" keybinding="a"/>
            <KeyboardShortcutLabel name="Search class" keybinding="/"/>
            <KeyboardShortcutLabel name="Bring to front" keybinding="cmd/ctrl ↑"/>
            <KeyboardShortcutLabel name="Send to back" keybinding="cmd/ctrl ↓"/>
            <KeyboardShortcutLabel name="Show classifications" keybinding="period"/>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        {
          editing ?
            (
              <ActionButtons>
                <Button disabled={disableSubmit} onClick={() => onReset()}>Reset</Button>
                <Tooltip title="or press e" placement="right">
                  <Button disabled={disableSubmit} color="primary" variant="raised" onClick={() => onSubmit()}>Save</Button>
                </Tooltip>
              </ActionButtons>
            ) :
            (
              <ActionButtons>
                <Tooltip title="or press a" placement="left">
                  <Button onClick={() => onSkip()}>Skip</Button>
                </Tooltip>
                <Tooltip title="or press e" placement="right">
                  <div><Button color="primary" variant="raised" disabled={disableSubmit} onClick={() => onSubmit()}>Submit</Button></div>
                </Tooltip>
              </ActionButtons>
            )
        }
      </div>

    </ToolbarContainer>
  );
}



// WEBPACK FOOTER //
// ./src/toolbar/toolbar.tsx